module.exports = "//public.zight.com/packs/media/images/apple_logo-4aa76b6c6552cfb1c1fa13ca85317181.svg";